import { ParticipantStatus } from '../../types';
import { ClientInformationDrawerBodyWrapper as ClientInformationDrawerBody } from './ClientInformationDrawerBodyWrapper';
import { ClientInformationDrawerFooterWrapper as ClientInformationDrawerFooter } from './ClientInformationDrawerFooterWrapper';
import { ClientInformationDrawerHeaderWrapper as ClientInformationDrawerHeader } from './ClientInformationDrawerHeaderWrapper';
import { ClientInformationSchedulingDrawerFooterWrapper as ClientInformationSchedulingDrawerFooter } from './ClientInformationSchedulingDrawerFooterWrapper';

type ClientInformationDrawerProps = {
  visitorName?: string;
  patientShortId?: string;
  isEmpty: boolean;
  visitorStatus?: ParticipantStatus;
  visitorUuid?: string;
  selectedPatientShortId: string | undefined;
};

export function ClientInformationDrawer({
  isEmpty,
  visitorName,
  visitorStatus,
  visitorUuid,
  selectedPatientShortId,
}: ClientInformationDrawerProps) {
  const isScheduledClient = visitorStatus === ParticipantStatus.SCHEDULED;
  return (
    <>
      <ClientInformationDrawerHeader
        visitorName={visitorName}
        visitorStatus={visitorStatus}
        selectedPatientShortId={selectedPatientShortId || ''}
      />
      <ClientInformationDrawerBody isEmpty={isEmpty} />
      {isScheduledClient && <ClientInformationSchedulingDrawerFooter />}
      {!isScheduledClient && (
        <ClientInformationDrawerFooter
          visitorStatus={visitorStatus}
          visitorUuid={visitorUuid || ''}
          visitorName={visitorName || ''}
          patientShortId={selectedPatientShortId || ''}
        />
      )}
    </>
  );
}
